import { Link } from 'gatsby'
import React from 'react'
import * as headerStyles from './styles/layout.module.scss'

const menuList = [
  { name: 'Token', link: '/' },
  { name: 'Address', link: '/address/' },
  { name: 'Transaction', link: '/transactions/' }
]

const Header = ({ path }) => {
  console.log('path', path)
  return (
    <header className={headerStyles.header}>
      <div className={headerStyles.wrapper}>
        {menuList.map((menu) => {
          return (
            <h3 key={menu.name}>
              <Link
                to={menu.link}
                className={path === menu.link ? headerStyles.activeM : ''}
              >
                {menu.name}
              </Link>
            </h3>
          )
        })}
      </div>
    </header>
  )
}

export default Header
